import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import i18n from './i18n/i18n';
import { IntlProvider } from 'react-intl';
import { LanguageProvider } from '@beds2b-group/reusable-components';

import es from './i18n/engine/es.json';
import en from './i18n/engine/en.json';
import us from './i18n/engine/us.json'; // 🇺🇸 nuevo idioma

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// 🔍 Detecta idioma desde la URL
const pathLang = window.location.pathname.split('/')[1];

// 👇 Define los idiomas soportados
const availableLocales = ['es', 'en', 'us'];

// Si la URL tiene idioma válido, lo usa; si no, por defecto 'es'
const currentLocale = availableLocales.includes(pathLang) ? pathLang : 'es';

// 👇 Asocia el idioma con su archivo de traducciones
const messagesMap: Record<string, any> = {
  es,
  en,
  us,
};

const messages = messagesMap[currentLocale];

root.render(
  //<React.StrictMode>
  <IntlProvider
    locale={currentLocale}
    defaultLocale="es"
    messages={messages}
  >
    {/* Los componentes de la librería (widget, carrito, modales...) usan sus propias traducciones en el idioma de la URL (es, gb, us, mx, fr...).
        Al cambiar de idioma se recarga la página, así que basta con leerlo al arrancar */}
    <LanguageProvider language={pathLang}>
      <App i18n={i18n} />
    </LanguageProvider>
  </IntlProvider>
  //</React.StrictMode>
);

reportWebVitals();
